import styled from 'styled-components';
 
export const PreviewPaneWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: auto;
  background-color: #fff;
  padding: 16px;
 
  .hot-excel-preview {
    width: 100%;
    overflow: auto;
    height: 100%;
    box-sizing: border-box;
 
    .ht_master {
      table {
        border-collapse: collapse;
        width: 100%;
        table-layout: fixed;
 
        td,
        th {
          max-width: 400px;
          min-width: 120px;
          word-wrap: break-word;
          white-space: normal;
          text-align: center;
          vertical-align: middle;
          border: 1px solid #ccc;
          padding: 8px;
          box-sizing: border-box;
        }
      }
    }
 
    .htCore {
      td,
      th {
        font-size: 14px;
      }
    }
 
    .htBold {
      font-weight: bold;
    }
 
    .htCenter {
      text-align: center !important;
    }
 
    .htMiddle {
      vertical-align: middle !important;
    }
  }
`;

export const ExcelSelectorsWrapper = styled.span`
  display: flex;
  flex-direction: row;

  select {
    color: ${({ theme }) => theme.colors.textColor};
    background-color: ${({ theme }) => theme.colors.background};
    box-shadow: ${({ theme }) => theme.shadows.boxShadowMini};
  }

  select:focus-visible { 
    outline: none;
    border: none;
  }
`